import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import type { SelectOption } from '@core/user-interface-legacy';
import {
  GroupComponent,
  InputComponent,
  TypeaheadComponent,
  TypeaheadInputDirective,
} from '@core/user-interface-legacy';
import { includesWithTrim } from '@core/utils-legacy';

import type { DynamicTypeaheadInputConfig } from '../../../types';
import { DynamicFormInput } from '../dynamic-form-input/dynamic-form-input';

export class TypeaheadInput extends DynamicFormInput<DynamicTypeaheadInputConfig> {}

@Component({
  selector: 'rti-dynamic-typeahead-input',
  templateUrl: './dynamic-typeahead-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GroupComponent,
    InputComponent,
    ReactiveFormsModule,
    TypeaheadComponent,
    TypeaheadInputDirective,
  ],
})
export class DynamicTypeaheadInputComponent {
  public readonly input = input<TypeaheadInput>(undefined!);

  public suggestions: Array<SelectOption<string>> = [];

  public onChange(query: string): void {
    const searchValue = query.toLowerCase();

    this.suggestions = this.input()
      .config.options.filter(option => includesWithTrim(option, searchValue, { trim: false }))
      .map(option => ({ label: option, value: option }));
  }
}
